import { includes, toPairs } from 'lodash';
import { ISdcStore } from 'src/app/sdc/flux/sdc-store.interface';

/**
 * Pusher DOM Helper Service:
 * Use this service when you need to manipulate the DOM ( IE: show a toast on a pusher-event )
 * Currently, all Pusher subscriptions are handled on initialization of the SDCStore.
 * Our state management architecture should NOT be interacting with our ui.
 * To handle this issue, use this service when you need to manipulate the DOM on a pusher event(jj)
 */
export interface IEvents {
  [key: string]: {
    handler: (any) => void;
    sdcKeys: string[];
  };
}

export class PusherDOMHelper {
  static $inject = ['SDCStore'];

  constructor(private SDCStore: ISdcStore) {}

  // TODO: Rethink use-case and rework logic taking into consideration new state management architecture (JJ)
  displayForCurrentSDC(sdcKeys: string[]): boolean {
    // if no sdcKeys are specified, default to all SDCs
    if (!sdcKeys) return true;
    const currentSdcKey: string = this.SDCStore.getSdcKeyFromUiState();
    return includes(sdcKeys, currentSdcKey);
  }
  /**
   * channel: The pusher channel object -- `private-school-< schoolId >`
   * events: `IEvents` object where keys are pusher events
   * sdcKeys: array of valid sdcs or null
   *
   * this function returns an object where the keys are events and the val is an unsubscribe fn
   */
  bindEventsToChannel(channel, events: IEvents): IEvents {
    let unbindObject: IEvents = Object.create(null);
    const eventsList: any = toPairs(events);
    eventsList.forEach(([eventName, eventDetails]) => {
      const { sdcKeys, handler } = eventDetails;
      if (!this.displayForCurrentSDC(sdcKeys)) return;
      unbindObject[eventName] = channel.bind(eventName, handler);
    });
    return unbindObject;
  }

  unbindEventsFromChannel(channel, events: IEvents) {
    const eventsList: any = toPairs(events);
    eventsList.forEach(([event, handler]) => {
      channel.unbind(event, handler);
    });
  }
}
